import React from "react";
import banner from "../../assets/projects/doc_translation_banner.png";
import ss1 from "../../assets/screenshots/doctranslation/ss1.png"
import ss2 from "../../assets/screenshots/doctranslation/ss2.png"

const DocumentTranslationAutomationPage = () => (
  <main className="container mx-auto max-width pt-10 pb-20 space-y-16">

  {/* Banner Image */}
  <section className="w-full">
    <img
      src={banner}
      alt="Document Translation Automation Banner"
      className="w-[500px] rounded-xl shadow-md object-cover"
    />
  </section>

  {/* Project Title & Overview */}
  <section>
    <h1 className="text-4xl xl:text-5xl font-bold text-dark-heading dark:text-light-heading mb-4">
      Document Translation Automation
    </h1>
    <p className="text-lg text-content lg:max-w-4xl">
      Document Translation Automation is a fully automated document processing system built with n8n, OpenAI, Google Docs, and Google Drive. The automation scans a dedicated "Pending Translation" folder in Google Drive, translates the documents to a target language using AI, organizes the translated results, converts them into PDF format, and sends the final results directly to a configured email address. This automation removes the need for manual document translation and file management while ensuring that translated documents are properly stored and delivered.
    </p>
  </section>

  {/* Live Demo */}
  <section>
    <h2 className="text-3xl font-semibold text-dark-heading dark:text-light-heading mb-4">
      ▶️ Live Demo
    </h2>
    <div className="w-full aspect-video">
      <iframe
        className="w-full h-full rounded-lg shadow"
        src="https://www.youtube.com/embed/7AQRGm9rXSg"
        title="Document Translation Automation Demo"
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
      ></iframe>
    </div>
  </section>

  {/* Technology Stack */}
  <section>
    <h2 className="text-3xl font-semibold text-dark-heading dark:text-light-heading mb-4">
    💻 Technology Stack
    </h2>
    <ul className="list-disc list-inside text-content space-y-2">
      <li><strong>n8n:</strong> Core automation platform that orchestrates the entire workflow</li>
      <li><strong>Google Drive:</strong> Stores original documents, translated documents, and generated PDFs</li>
      <li><strong>Google Docs API:</strong> Accesses and processes Google document content</li>
      <li><strong>OpenAI (ChatGPT):</strong> Performs the document translation using AI</li>
      <li><strong>Email Integration:</strong> Sends the final translation results and file links to the specified email</li>
    </ul>
  </section>

  {/* Main Automation Workflow */}
  <section>
    <h2 className="text-3xl font-semibold text-dark-heading dark:text-light-heading mb-4">
      🤖 Main Automation Workflow (n8n)
    </h2>
    <ul className="list-disc list-inside text-content space-y-2">
      <li>Set the source language and target language for translation</li>
      <li>Set the email address where the translation results will be sent</li>
      <li>Search Google Docs files inside the "Pending Translation" folder</li>
      <li>Loop through all discovered documents</li>
      <li>For each file, call the Google Doc Translation Sub Workflow</li>
      <li>After translation completes, convert the translated document into PDF format</li>
      <li>Upload the generated PDF into the "Complete Translation PDF" folder</li>
      <li>After all files are processed, send an email containing all translation results and links</li>
    </ul>
  </section>

  {/* Translation Sub Workflow */}
  <section>
    <h2 className="text-3xl font-semibold text-dark-heading dark:text-light-heading mb-4">
      🔄 Document Translation Sub Workflow (n8n)
    </h2>
    <ul className="list-disc list-inside text-content space-y-2">
      <li>Receive the document file from the main workflow</li>
      <li>Extract the document content</li>
      <li>Translate the document using AI</li>
      <li>Create a translated version of the document</li>
      <li>Upload the translated document into the "Complete Translation & Original Document" folder</li>
      <li>Move the original document to the same folder to keep both versions organized</li>
    </ul>
  </section>

  {/* Automated Document Management */}
  <section>
    <h2 className="text-3xl font-semibold text-dark-heading dark:text-light-heading mb-4">
      📂 Automated Document Management
    </h2>
    <ul className="list-disc list-inside text-content space-y-2">
      <li>Automatically detects new documents ready for translation</li>
      <li>Keeps translated documents organized in a dedicated folder</li>
      <li>Moves original documents to prevent duplicate processing</li>
      <li>Generates PDF versions for easy sharing and distribution</li>
      <li>Sends email notifications containing all final translation outputs</li>
    </ul>
  </section>

  {/* Screenshots */}
  <section>
  <h2 className="text-3xl font-semibold text-dark-heading dark:text-light-heading mb-4">
    🖼️ Project Images & Screenshots
  </h2>

  <div className="flex flex-col gap-6">
    <div>
      <p className="mb-2 font-medium">Key Features</p>
      <a href={banner} target="_blank" rel="noopener noreferrer">
        <img src={banner} alt="Main Workflow" className="w-full rounded-lg shadow" />
      </a>
    </div>
    <div>
      <p className="mb-2 font-medium">Main Document Translation Automation Workflow (n8n)</p>
      <a href={ss1} target="_blank" rel="noopener noreferrer">
        <img src={ss1} alt="Main Workflow" className="w-full rounded-lg shadow" />
      </a>
    </div>


    <div>
      <p className="mb-2 font-medium">Final Email Result with Translated Documents</p>
      <a href={ss2} target="_blank" rel="noopener noreferrer">
        <img src={ss2} alt="Email Result" className="w-full rounded-lg shadow" />
      </a>
    </div>

  </div>
</section>

</main>
);

export default DocumentTranslationAutomationPage;
